<template>
    <div class="container" :class="theme">
        <div class="title-group">
            <h3 class="main-title">{{title}}</h3>
            <h4 class="sub-title">{{text}}</h4>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'content-box',
    props: ['title', 'text', 'theme']
};
</script>

<style lang="less">
.title-group {
    text-align: center;
    padding: 0.50rem 0;
    .main-title {
        color: #000;
        font-size: 32px;
        line-height: 2em;
        text-align: center;
    }
    .sub-title {
        color: #333;
        font-size: 18px;
        line-height: 1.5em;
        max-width: 75%;
        margin: 0 auto;
    }
}
.white {
    .title-group {
        .main-title {
            color: #fff;
        }
        .sub-title {
            color: #fff;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .title-group {
        .main-title {
            font-size: 28px;
        }
        .sub-title {
            font-size: 16px;
        }
    }
}
@media screen and (min-width: 481px) and (max-width: 839px) {
    .title-group {
        .main-title {
            font-size: 24px;
        }
        .sub-title {
            font-size: 14px;
        }
    }
}

@media screen and (max-width: 480px) {
    .title-group {
        padding: 0.25rem 0.15rem;
        .main-title {
            font-size: 16px;
            margin-bottom: 0.1rem;
        }
        .sub-title {
            max-width: 100%;
            font-size: 12px;
        }
    }
}
</style>